import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserComponent} from './user.component';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '../../../shared/shared.module';
import {NgxPaginateModule} from 'ngx-paginate';
import {NgxLoadingModule} from 'ngx-loading';


export const userRoutes: Routes = [
  {
    path: '',
    component: UserComponent,
    data: {
      breadcrumb: 'Users',
      icon: 'icofont-home bg-c-blue',
      status: false
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(userRoutes),
    SharedModule,
    NgxPaginateModule,
    NgxLoadingModule
  ],
  declarations: [UserComponent]
})
export class UserModule {
}



// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/listing/user/user.module.ts